import { useAppDispatch } from 'app/hooks';
import { FETCH_ALL_PARAMS } from 'constants/query';
import { useLazyGetPlacesQuery } from 'features/place/services';
import { useLazyGetWebsitesQuery } from 'features/website/services';
import { useAuth } from 'hooks/useAuth';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setWorkspace } from 'store/workspace-slice';

// Enhanced WorkspaceGuard.tsx
export const WorkspaceGuard = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [getWebsites] = useLazyGetWebsitesQuery();
    const [getPlaces] = useLazyGetPlacesQuery();
    const { accessToken } = useAuth();

    const extractWorkspaceFromUrl = () => {
        const match = location.pathname.match(/^\/admin\/workspace\/([a-f0-9-]+)/i);
        return match ? match[1] : undefined;
    };

    const urlWorkspaceId = extractWorkspaceFromUrl();

    useEffect(() => {
        if (!accessToken) {
            navigate('/login', { replace: true });
            return;
        }
        let isMounted = true;

        const verifyWorkspace = async () => {
            if (!urlWorkspaceId) {
                navigate('/not-found');
                return;
            }

            try {
                const websites = await getWebsites(FETCH_ALL_PARAMS);
                const website = websites.data?.content.find((w) => w.id === urlWorkspaceId);

                if (!website) {
                    navigate('/not-found');
                    return;
                }
                const places = await getPlaces({
                    ...FETCH_ALL_PARAMS,
                    website_id: urlWorkspaceId,
                });

                const firstPlaceId = places.data?.content[0]?.id || '';

                if (isMounted) {
                    dispatch(
                        setWorkspace({
                            websiteId: urlWorkspaceId,
                            websiteName: website.name,
                            placeId: firstPlaceId,
                            baseWorkspaceUrl: `/admin/workspace/${urlWorkspaceId}`,
                        }),
                    );
                }
            } catch (error) {
                if (isMounted) {
                    navigate('/error');
                }
            }
        };

        verifyWorkspace();

        return () => {
            isMounted = false;
        };
    }, [urlWorkspaceId, navigate, dispatch, getWebsites, getPlaces, accessToken]);

    return null;
};
